/* NIVA — gestes premium. Sobres, jamais de rebond, jamais de parallaxe.
   Tout est desactive si l'utilisateur a demande a reduire les animations. */
(function () {
  'use strict';

  /* Le snippet niva-tokens est rendu par chaque section : sans ce garde, le
     script s'executerait une fois par section et empilerait les ecouteurs. */
  if (window.__nivaMotion) return;
  window.__nivaMotion = true;

  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. Apparition au defilement -------------------------------------- */
  var CIBLES = [
    '.nve', '.nvp', '.nvn', '.nvl',
    '.nvs-ben__content', '.nvs-ben__img',
    '.nvs-maison__content', '.nvs-maison__img',
    '.nvs-ba__col', '.nvs-rev__carte',
    '.nv-reveal',
    '.card-wrapper',
    '.article-card',
    '.rich-text__wrapper',
    '.multicolumn-card',
    '.collection-list__item'
  ].join(',');

  function armer() {
    if (reduit || !('IntersectionObserver' in window)) return;

    var elements = document.querySelectorAll(CIBLES);
    if (!elements.length) return;

    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('nv-vu');
        obs.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });

    var vus = 0;
    elements.forEach(function (el) {
      if (el.hasAttribute('data-nv-reveal')) return;
      /* ce qui est deja visible au chargement ne doit pas clignoter */
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) return;

      el.setAttribute('data-nv-reveal', '');
      /* leger decalage en cascade entre freres, plafonne a 3 crans */
      if (el.parentElement) {
        var i = Array.prototype.indexOf.call(el.parentElement.children, el);
        if (i > 0) el.setAttribute('data-nv-delay', String(Math.min(i, 3)));
      }
      obs.observe(el);
      vus++;
    });
    return vus;
  }

  /* ---- 2. En-tete qui se resserre --------------------------------------- */
  function enTete() {
    var seuil = 40, actif = false, enAttente = false;
    function maj() {
      var doit = window.scrollY > seuil;
      if (doit !== actif) {
        actif = doit;
        document.body.classList.toggle('nv-defile', actif);
      }
      enAttente = false;
    }
    window.addEventListener('scroll', function () {
      if (enAttente) return;
      enAttente = true;
      window.requestAnimationFrame(maj);
    }, { passive: true });
    maj();
  }

  /* ---- 3. Ancres internes en defilement doux ---------------------------- */
  function ancres() {
    if (reduit) return;
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href');
      if (!id || id === '#' || id.length < 2) return;
      var cible = document.querySelector(id);
      if (!cible) return;
      ev.preventDefault();
      cible.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---- 4. Moon Bundles : choisir une couleur ne remonte pas la page ----- */
  /* Le widget de packs declenche le changement de variante du theme, et le
     theme fait alors defiler la page jusqu'a l'image de la variante. On
     neutralise ce defilement UNIQUEMENT juste apres une interaction a
     l'interieur d'un bloc d'application : le selecteur de couleur du theme,
     lui, garde son comportement normal. */
  function bundleSansSaut() {
    var jusqua = 0;
    var BLOCS = '.shopify-app-block,[id^="shopify-block-"],[class*="moon"],[class*="mnb"],[class*="bundle"]';
    function marquer(e) {
      var t = e.target;
      if (t && t.closest && t.closest(BLOCS)) jusqua = Date.now() + 1200;
    }
    document.addEventListener('pointerdown', marquer, true);
    document.addEventListener('change', marquer, true);

    var GALERIE = 'media-gallery,.product__media-wrapper,.product__media-list,.thumbnail-list';
    var siv = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function () {
      if (Date.now() < jusqua && this.closest && this.closest(GALERIE)) return;
      return siv.apply(this, arguments);
    };
    var sto = Element.prototype.scrollTo;
    Element.prototype.scrollTo = function () {
      if (Date.now() < jusqua && this.closest && this.closest(GALERIE)) return;
      return sto.apply(this, arguments);
    };
  }

  function demarrer() {
    armer();
    enTete();
    ancres();
    bundleSansSaut();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  /* Les sections rechargees par l'editeur de theme doivent etre re-armees */
  document.addEventListener('shopify:section:load', armer);
  document.addEventListener('shopify:section:select', armer);
})();
